import React, { memo } from 'react'
import Checkbox from '@material-ui/core/Checkbox'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import checkedIcon from 'assets/images/vector.svg'
import { hex } from 'utils/hex'

const useStyles = makeStyles(() => ({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    borderRadius: 6,
    width: 24,
    height: 24,
    boxShadow:
      'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#ffffff',
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    // 'input:hover ~ &': {
    //   //backgroundColor: '#ebf1f5',
    // },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },
  checkedIcon: (pr) => ({
    backgroundColor: pr.color || '#1772F5',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    '&:before': {
      position: 'absolute',
      display: 'block',
      width: 24,
      height: 24,
      backgroundImage: `url(${checkedIcon})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: hex(pr.color || '#1772F5', 0.8),
    },
  }),
}))

const CheckboxStyled = ({
  color = '#1772F5',
  className,
  dataId = '',
  ...rest
}) => {
  const classes = useStyles({ color })
  return (
    <Checkbox
      className={`${classes.root} ${className}`}
      color="default"
      checkedIcon={
        <span className={clsx(classes.icon, classes.checkedIcon)}></span>
      }
      icon={<span className={classes.icon} />}
      inputProps={{
        ['data-id']: dataId,
      }}
      label="asdasdasd"
      {...rest}
    />
  )
}

export default memo(CheckboxStyled)
